import { buildSavePayload } from './survey-answer-payload'
import { isChoiceDraftAnswer } from './choice-answer'
import { findSurveyQuestion } from './parse-survey-definition'
import type { SurveyDefinition, SurveyDraftAnswer } from './survey-question.types'

export function resolveSurveyNextButtonLabel(
  nextPending: boolean,
  isLastQuestion: boolean,
): string {
  if (nextPending) {
    return isLastQuestion ? 'Submitting…' : 'Saving…'
  }
  return isLastQuestion ? 'Submit' : 'Next'
}

export function mapAnswersToResponseEntries(
  definition: SurveyDefinition,
  answers: Map<string, SurveyDraftAnswer>,
): Array<{
  questionId: string
  rawText?: string
  structuredValue?: string | string[] | number
}> {
  return Array.from(answers.entries())
    .filter((entry): entry is [string, NonNullable<SurveyDraftAnswer>] => {
      const val = entry[1]
      return val != null && (!Array.isArray(val) || val.length > 0)
    })
    .map(([questionId, val]) => {
      if (Array.isArray(val)) {
        return { questionId, structuredValue: val }
      }
      if (typeof val === 'string') {
        const q = findSurveyQuestion(definition, questionId)
        if (q && (q.type === 'short_text' || q.type === 'long_text')) {
          return { questionId, rawText: val }
        }
        return { questionId, structuredValue: val }
      }
      if (typeof val === 'number') {
        return { questionId, structuredValue: val }
      }
      if (isChoiceDraftAnswer(val)) {
        const q = findSurveyQuestion(definition, questionId)
        if (q) return buildSavePayload(q, val)
        return { questionId, structuredValue: val.selectedIds }
      }
      return { questionId, structuredValue: '' }
    })
}
